import styled from 'styled-components/native';
import { Feather as IconsFE, FontAwesome5 as IconsFA5 } from '@expo/vector-icons';
import { themes } from '../../../design/colors';
import Constants from 'expo-constants';

export const Container = styled.View`
    flex: 1;
`;

export const Content = styled.View`
    padding: 20px;
    margin-top: ${Constants.statusBarHeight + -150}px;
`;

export const Header = styled.View`
    background-color: ${themes.colors.primary};
    padding: ${Constants.statusBarHeight + 12}px 16px;
    flex-direction: row;
    justify-content: space-between;
    height: 200px;
`;

export const Title = styled.Text`
    color: ${themes.colors.white};
    font-size: 16px;
    font-weight: bold;
`;

export const IconFE = styled(IconsFE)``;

export const IconFA5 = styled(IconsFA5)``;

export const TextButton = styled.Text`
  color: ${themes.colors.white};
  flex: 1;
  text-align: center;
  top: 15px;
  font-weight: bold;
  font-size: 16px;
`;

export const Button = styled.TouchableOpacity`
  background-color: ${themes.colors.primary};
  margin-top: 30px;
  height: 50px;
  border-radius: 5px;
`;

export const Input = styled.TextInput`
  height: 300px;
  background-color: ${themes.colors.white};
  padding: 20px;
  font-size: 16px;
  shadow-color: #000;
  shadow-opacity: 0.23px;
  shadow-radius: 2.62px;
  elevation: 1px;
  border-radius: 5px;
`;